import { useState } from "react";
import { useReveal } from "@/hooks/useReveal";

const FAQS = [
  {
    q: "Can you hold a tighter tolerance than the published specification?",
    a: "Usually yes, within a range agreed in advance and written into the supply agreement. Tell us the parameter and the limit your process needs.",
  },
  {
    q: "What happens if a batch is out of specification?",
    a: "It does not ship. The CoA is issued before dispatch, and we would rather delay a shipment than send you material that forces a reformulation.",
  },
  {
    q: "Can you complete our supplier homologation questionnaire?",
    a: "Yes. We can also supply process flow diagrams, traceability records and the audit history ahead of any plant visit.",
  },
  {
    q: "Is the colour consistent between harvests?",
    a: "Colour varies naturally with harvest because nothing is added to standardise it. If your application needs a narrow colour band, say so and we will confirm whether we can hold it before you homologate us.",
  },
  {
    q: "Do you supply samples for trial runs?",
    a: "Product samples are quoted separately. Pilot-scale quantities for a trial run are quoted separately.",
  },
  {
    q: "What is your realistic ceiling if our volume grows?",
    a: "One to two 40 ft containers per quarter is what we will commit to. Beyond that we will tell you rather than accept and then ration.",
  },
];

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  const ref = useReveal<HTMLDivElement>();

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-[800px] mx-auto px-4 md:px-6">
        <div ref={ref} className="reveal text-center">
          <h2 className="text-ink font-serif text-3xl md:text-4xl font-semibold">
            Questions from technical buyers
          </h2>
        </div>

        <div className="mt-12 space-y-3">
          {FAQS.map((item, i) => {
            const isOpen = open === i;
            return (
              <div
                key={item.q}
                className="border border-cream-dark/60 rounded-lg overflow-hidden"
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? null : i)}
                  aria-expanded={isOpen}
                  className="w-full flex items-center justify-between gap-4 px-5 md:px-6 py-4 text-left"
                >
                  <span className="text-ink font-serif text-base md:text-lg font-semibold">
                    {item.q}
                  </span>
                  <i
                    className={`text-brown text-xl transition-transform duration-300 ${
                      isOpen ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  ></i>
                </button>
                {isOpen && (
                  <div className="px-5 md:px-6 pb-5">
                    <p className="text-ink/70 text-[17px] leading-relaxed">
                      {item.a}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}